import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Card, CardContent } from '../../components/ui/card';
import { toast } from 'sonner';
import { Loader2, Trophy, XCircle } from 'lucide-react';
import { Button } from '../../components/ui/button';

export default function GoogleCallbackPage() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { processGoogleCallback } = useAuth();
    const [status, setStatus] = useState('loading'); // loading, error
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        const code = searchParams.get('code');
        const error = searchParams.get('error');

        if (error) {
            setStatus('error');
            setErrorMessage('Autenticación cancelada');
            return;
        }

        if (!code) {
            setStatus('error');
            setErrorMessage('No se recibió código de autorización');
            return;
        }

        const processCallback = async () => {
            try {
                await processGoogleCallback(code);
                toast.success('¡Bienvenido!');
                navigate('/dashboard');
            } catch (error) {
                setStatus('error');
                setErrorMessage(error.response?.data?.detail || 'Error al iniciar sesión con Google');
            }
        };

        processCallback();
    }, [searchParams, processGoogleCallback, navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-background via-background to-primary/5">
            <div className="w-full max-w-md">
                <div className="text-center mb-8">
                    <div className="inline-flex items-center gap-2">
                        <Trophy className="w-10 h-10 text-primary" />
                        <span className="font-heading text-3xl font-black">POLLA REMAKIA</span>
                    </div>
                </div>

                <Card className="border-border/50 shadow-xl">
                    <CardContent className="pt-8 pb-8 text-center">
                        {status === 'loading' && (
                            <div>
                                <Loader2 className="w-16 h-16 text-primary animate-spin mx-auto mb-4" />
                                <h2 className="text-2xl font-bold mb-2">Iniciando sesión...</h2>
                                <p className="text-muted-foreground">
                                    Conectando con tu cuenta de Google
                                </p>
                            </div>
                        )}

                        {status === 'error' && (
                            <div>
                                <div className="w-16 h-16 bg-destructive/10 rounded-full flex items-center justify-center mx-auto mb-4">
                                    <XCircle className="w-8 h-8 text-destructive" />
                                </div>
                                <h2 className="text-2xl font-bold mb-2">Error de Autenticación</h2>
                                <p className="text-muted-foreground mb-6">{errorMessage}</p>
                                <Button 
                                    onClick={() => navigate('/login')}
                                    className="w-full"
                                >
                                    Volver a Iniciar Sesión
                                </Button>
                            </div>
                        )}
                    </CardContent>
                </Card>
            </div>
        </div>
    );
}
